import React, { Component } from "react";
import "./SpaLandingReserved.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import SpaReservationCard from './SpaReservationCard';
import FocusLock from 'react-focus-lock';

class SpaLandingReserved extends Component {
    constructor(props, context) {
        super(props, context);

        //this.handleShowCancelPopup = this.handleShowCancelPopup.bind(this);
        this.handleCloseCancelPopup = this.handleCloseCancelPopup.bind(this);

        this.state = {
            showPopup: false,
            showCancelPopup: false,
            serviceName: "",
            showCancelledServiceMsg: false,
            selectedItem: {},
            Reservations: []
        }
    }

    handleCloseCancelPopup() {
        this.setState({ showCancelPopup: false, trapFocus: false });
    }

    handleShowCancelPopup(reservedService) {
        window.scrollTo(0, this.props.payRef.offsetTop + 150);
        this.setState({ showCancelPopup: true, trapFocus: true, serviceName: reservedService.appointment.treatmentName, selectedService: reservedService }, () => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div>
                            <div role='alert' className="spa-popup-custom-ui" data-test-id="cancel-pop-up-window">
                                <p role='alert' className="gotham-xn-book font-size-p02" data-test-id="cancel-pop-up-title">Are you sure you wish to cancel: {this.state.serviceName}</p>
                                <FocusLock>
                                    <button className="button gotham-xn-medium primary-btn font-size-p5 spa-popup-button" data-test-id="cancel-yes" onClick={() => { this.cancelSelectedService(reservedService); onClose(); }}>Yes</button>
                                    <button className="button gotham-xn-medium secondary-btn font-size-p5 spa-popup-button" data-test-id="cancel-no" onClick={() => { this.handleCloseCancelPopup(); onClose(); }}>No</button>
                                </FocusLock>
                            </div>
                        </div>
                    );
                }
            });
        });

    }

    cancelSelectedService(item) {
        this.props.actions.cancelSelectedService(item);
        this.setState({ showCancelledServiceMsg: true });
    }

    DisplayReservations(reservationsList, contentFeedData, ShipboardCurrencyCode) {

        let reservationItem = null;
        reservationItem = reservationsList.map((item) => {

            return ((item.appointment.TreatmentPrice) ?
                <SpaReservationCard daysToCruise={this.props.daysToCruise} openDetailsPage={this.props.openDetailsPage} ShipboardCurrencyCode={ShipboardCurrencyCode} contentFeedData={contentFeedData} handleShowCancelPopup={this.handleShowCancelPopup.bind(this, item)} item={item} />
                : null
            )
        })
        return reservationItem;
    }

    render() {
        let Reservations = this.props.services.reservedServices || [];
        let { canceledService = false, contentFeedData = false, PaymentDetails = {} } = this.props.services;
        let { ShipboardCurrencyCode = 'USD' } = PaymentDetails;
        return (
            <ul className="spa-res-list list-style">
                {this.DisplayReservations(Reservations, contentFeedData, ShipboardCurrencyCode)}
                {canceledService &&
                    <div className="spa-box red spa-landing-cancel-bottom" data-test-id="reservation-cancel-text">
                        Your reservation  on {canceledService.appointment.formatedDate} at {canceledService.appointment.formatedTime} has been cancelled.
                    </div>
                }
            </ul>
        );
    }
}

export default SpaLandingReserved;


